<mat-card appearance="outlined" id="reset-pwd-card">
  <mat-toolbar> <span>Reset Password</span> </mat-toolbar>
  <mat-card-content>
    @if ((bannerStatus$ | async)) {
      <mat-toolbar
        id="reset-pwd-banner"
        color="{{ bannerColor$ | async }}"
        fxFlexFill
        >
        <span id="reset-pwd-banner-message">
          {{ bannerMessage$ | async }}
        </span>
      </mat-toolbar>
    }
    @if (showProgressBar) {
      <mat-progress-spinner
        mode="indeterminate"
      ></mat-progress-spinner>
    }
    @if (hash && !formSubmitted) {
      <div id="reset-pwd-container">
        <p>
          Please enter a new password.
        </p>
        <form
          novalidate
          id="reset-pwd-form"
          [formGroup]="passwordForm"
          (ngSubmit)="submit()"
          >
          <mat-form-field>
            <input
              id="reset-new-pwd-field"
              matInput
              placeholder="Password"
              [type]="hide1 ? 'password' : 'text'"
              formControlName="newPassword"
              required
              />
            <mat-icon
              id="reset-new-pwd-icon"
              class="reset-pwd-icon"
              matSuffix
              fontSet="fa"
              fontIcon="{{ hide1 ? 'fa-eye-slash' : 'fa-eye' }}"
              (click)="hide1 = !hide1"
              (keyup)="markAsTouched($event)"
              >
            </mat-icon>
            @if (validate('newPassword', 'required')) {
              <mat-error>
                Password is required
              </mat-error>
            }
            @if (
              validate('newPassword', 'pwdLength') &&
              !validate('newPassword', 'required')
              ) {
              <mat-error
                >
                Value must be a valid password
              </mat-error>
            }
          </mat-form-field>
          <mat-chip-listbox>
            <mat-chip-option
              color="{{ chipColor('pwdLength') }}"
              selected="true"
              >8-256 Characters</mat-chip-option
              >
            </mat-chip-listbox>
            <mat-form-field>
              <input
                id="reset-confirm-pwd-field"
                matInput
                placeholder="Confirm Password"
                [type]="hide2 ? 'password' : 'text'"
                formControlName="confirmPassword"
                required
                />
              <mat-icon
                id="reset-confirm-pwd-icon"
                class="reset-pwd-icon"
                matSuffix
                fontSet="fa"
                fontIcon="{{ hide2 ? 'fa-eye-slash' : 'fa-eye' }}"
                (click)="hide2 = !hide2"
                (keyup)="markAsTouched($event)"
                >
              </mat-icon>
              @if (validate('confirmPassword', 'required')) {
                <mat-error>
                  Confirm password is required
                </mat-error>
              }
              @if (
                validate('confirmPassword', 'matchPassword') &&
                !validate('confirmPassword', 'required')
                ) {
                <mat-error
                  >
                  Value does not match
                </mat-error>
              }
            </mat-form-field>
            <div
              id="form-buttons"
              fxLayout="row"
              fxLayoutWrap
              fxLayoutAlign="end"
              >
              <button
                id="form-back-button"
                class="back-button support-buttons"
                mat-raised-button
                (click)="cancel()"
                type="button"
                color="secondary"
                >
                Cancel
              </button>
              <button
                id="submit-button"
                class="support-buttons"
                mat-raised-button
                color="primary"
                type="submit"
                        [disabled]="
                            passwordForm.untouched || !passwordForm.valid
                        "
                >
                Reset Password
              </button>
            </div>
          </form>
        </div>
      }
      @if (formSubmitted) {
        <div id="placeholder-field"></div>
      }
    </mat-card-content>
    <mat-card-actions>
      @if (!hash || (formSubmitted && !showProgressBar)) {
        <button
          id="cancel-link"
          mat-raised-button
          fxFill
          color="primary"
          (click)="cancel()"
          >
          Back to Login
        </button>
      }
    </mat-card-actions>
  </mat-card>
